import { TablePaginationConfig } from 'antd/es/table';

export const QUOTE_CREATED_DATE_COLUMN_TITLE = 'Created Date';

export const normalizeDateRange = (min?: string, max?: string): [string, string] | undefined => {
    if (!min || !max) {
        return undefined;
    }

    return [min, max];
};

export const buildQuoteQueryParams = ({
    pagination,
    search,
    customerStatus,
    createdDates,
    completedDates,
    sorter,
}: {
    pagination?: TablePaginationConfig;
    search?: string;
    customerStatus?: string;
    createdDates?: [string, string];
    completedDates?: [string, string];
    sorter?: { field?: string; order?: string };
}): Record<string, unknown> => {
    const queryArr: Record<string, unknown> = {
        page: pagination?.current,
        include_quoting: true,
        page_size: pagination?.pageSize,
    };

    if (search) queryArr['search'] = search;
    if (customerStatus) queryArr['status'] = customerStatus;
    if (createdDates) {
        queryArr['created_time_min'] = createdDates[0];
        queryArr['created_time_max'] = createdDates[1];
    }
    if (completedDates) {
        queryArr['completed_at_min'] = completedDates[0];
        queryArr['completed_at_max'] = completedDates[1];
    }
    if (sorter?.field) {
        queryArr['ordering'] = `${sorter?.order === 'ascend' ? '' : '-'}${sorter.field}`;
    }

    return queryArr;
};
